module.exports = __webpack_public_path__ + "static/img/title-yysj.2ebb23d0.png";